import { useServices, useToast } from '@/app/providers';
import type { UnitCobranza } from '@yawi/types';
import { useState } from 'react';

interface UseUnitAccessArgs {
  patchUnit: (id: string, patch: Partial<UnitCobranza>) => void;
  onChanged?: () => void;
}

/**
 * Toggle de acceso por unidad con update optimista: la UI cambia de inmediato y
 * solo se revierte si el servidor falla. Afecta a todos los residentes de la unidad.
 */
export function useUnitAccess({ patchUnit, onChanged }: UseUnitAccessArgs) {
  const { cobranzaRepo } = useServices();
  const toast = useToast();
  const [pendingId, setPendingId] = useState<string | null>(null);

  const toggle = async (unit: UnitCobranza) => {
    const next = !unit.isBlocked;
    setPendingId(unit.id);
    patchUnit(unit.id, { isBlocked: next }); // optimista

    try {
      await cobranzaRepo.updateAccess(unit.id, next);
      onChanged?.();
    } catch {
      patchUnit(unit.id, { isBlocked: unit.isBlocked }); // rollback
      toast.error('No se pudo actualizar el acceso');
    } finally {
      setPendingId(null);
    }
  };

  return { toggle, pendingId };
}
